"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var react_1 = __importStar(require("react"));
var SelectSearchInput_1 = require("./SelectSearchInput");
var FocusHelper_1 = require("./FocusHelper");
var SelectComponents_1 = require("./SelectComponents");
var SelectUtils_1 = require("./SelectUtils");
var useSelect_1 = require("./useSelect");
var SelectionComponentContainer_1 = require("./SelectionComponentContainer");
exports.Select = function (props) {
    var _a, _b;
    var _c = SelectUtils_1.useSelectProps(props), inputProps = _c.inputProps, customComponents = _c.customComponents;
    var components = __assign(__assign({}, SelectComponents_1.defaultSelectComponents), customComponents);
    var _d = useSelect_1.useSelect(props), open = _d.open, close = _d.close, isOpen = _d.isOpen, isSearching = _d.isSearching, searchQuery = _d.searchQuery, onSearchChange = _d.onSearchChange, highlightedOption = _d.highlightedOption, setHighlightedOption = _d.setHighlightedOption, selectedOptions = _d.selectedOptions, onSelect = _d.onSelect, onSelectAll = _d.onSelectAll, onClearSelection = _d.onClearSelection, inputValue = _d.inputValue, options = _d.options, isAllSelected = _d.isAllSelected, onKeyDown = _d.onKeyDown, setHighlightedEl = _d.setHighlightedEl, setSearchableInputEl = _d.setSearchableInputEl;
    var Container = components.Container, Control = components.Control, Option = components.Option, OptionContainer = components.OptionContainer, Value = components.Value, ValueContainer = components.ValueContainer;
    // CONTROL EVENT HANDLING
    var _e = react_1.useState(), controlEl = _e[0], setControlEl = _e[1];
    var onControlMouseDown = function (e) {
        if (!isOpen) {
            open();
            e.preventDefault();
        }
        else if (!props.interactiveControl && !props.inlineSearch) {
            close();
        }
    };
    // RENDERING
    var renderOption = function (option) {
        var isHighlighted = option === highlightedOption;
        var isSelected = selectedOptions.includes(option);
        var ref = isHighlighted ? setHighlightedEl : undefined;
        if (isSelected && props.hideOptionOnSelection) {
            return null;
        }
        return (react_1.default.createElement(OptionContainer, { ref: ref, isHighlighted: isHighlighted, isDisabled: option.disabled, onClick: function (e) {
                e.preventDefault();
                onSelect(option);
            }, onMouseEnter: function () { return setHighlightedOption(option); } },
            react_1.default.createElement(Option, { multiple: props.multiple || false, option: option, isHighlighted: isHighlighted, isSelected: isSelected, isDisabled: option.disabled })));
    };
    var renderGroup = function (group) {
        // TODO Move into own component.
        // TODO also potentially move heading into its own component
        if (!group.options || group.options.length === 0) {
            return null;
        }
        return __spreadArrays([
            react_1.default.createElement("p", { className: "c-dropdown__group" }, group.heading)
        ], group.options.map(renderOption));
    };
    var renderOptions = function () {
        var optionsToRender = options
            .map(function (option) {
            if ("options" in option) {
                return renderGroup(option);
            }
            else {
                return renderOption(option);
            }
        })
            .filter(function (option) { return option !== null; });
        if (optionsToRender.length === 0) {
            return (react_1.default.createElement("div", { className: "u-align-center u-pad-small u-color-light" }, props.noOptionsText || "No options available"));
        }
        return optionsToRender;
    };
    return (react_1.default.createElement(Container, { tabIndex: 0, onKeyDown: onKeyDown },
        react_1.default.createElement(Control, { ref: setControlEl, onMouseDown: onControlMouseDown },
            react_1.default.createElement("div", { className: "l-app +x +gap-0" },
                react_1.default.createElement("div", { className: "l-app__item +middle" },
                    react_1.default.createElement(ValueContainer, { className: "u-flex u-flex-wrap u-width-100pc" },
                        (!props.searchable || !isOpen) && (react_1.default.createElement(FocusHelper_1.FocusHelper, { ref: setSearchableInputEl })),
                        selectedOptions.length === 0 &&
                            (props.inlineSearch ? searchQuery.length === 0 : true) ? (react_1.default.createElement("span", { className: "u-color-light", style: { pointerEvents: "none" } }, props.placeholderText || "Select an item")) : (selectedOptions.map(function (option) { return (react_1.default.createElement(Value, __assign({}, props.selectValueProps, { option: option, onOptionSelect: onSelect, className: "c-dropdown__selected-option" }), SelectUtils_1.formatOption(option))); })),
                        props.inlineSearch && (react_1.default.createElement("input", { ref: setSearchableInputEl, tabIndex: 0, onChange: onSearchChange, value: searchQuery, size: searchQuery.length || 1, type: "text", className: "c-input", style: {
                                background: 0,
                                border: 0,
                                fontSize: "inherit",
                                marginLeft: "5px",
                            } })))),
                react_1.default.createElement("div", { className: "l-app__item +end" }, isSearching && react_1.default.createElement("div", { className: "c-loader" })))),
        react_1.default.createElement(SelectionComponentContainer_1.SelectionComponentContainer, { isOpen: isOpen, controlElement: controlEl, requestClose: function () { return close(); }, interactiveControl: props.interactiveControl },
            react_1.default.createElement("div", __assign({}, props.selectionComponentProps, { className: "c-dropdown u-width-100pc u-pos-static u-max-height-100pc u-overflow-auto " + ((_b = (_a = props.selectionComponentProps) === null || _a === void 0 ? void 0 : _a.className) !== null && _b !== void 0 ? _b : "") }),
                ((props.searchable && !props.inlineSearch) ||
                    (props.canSelectAll && props.multiple)) && (react_1.default.createElement("div", { className: "c-dropdown__header" },
                    props.searchable && !props.inlineSearch && (react_1.default.createElement(SelectSearchInput_1.SelectSearchInput, { ref: setSearchableInputEl, onChange: onSearchChange, value: searchQuery, className: "c-input +fill +text", placeholder: "Search" })),
                    props.canSelectAll && props.multiple && (react_1.default.createElement("label", { className: "c-label u-font-regular" },
                        react_1.default.createElement("input", { className: "c-input", type: "checkbox", onChange: onSelectAll, checked: isAllSelected }),
                        "Select All")))),
                react_1.default.createElement("ul", { className: "c-dropdown__body", onMouseLeave: function () { return setHighlightedOption(undefined); } }, renderOptions()),
                selectedOptions.length > 0 && (react_1.default.createElement("div", { className: "c-dropdown__footer" },
                    react_1.default.createElement("button", { className: "c-button +text", onClick: onClearSelection }, "Clear selection"))))),
        react_1.default.createElement("input", __assign({}, inputProps, { type: "hidden", value: inputValue }))));
};
//# sourceMappingURL=Select.js.map